export const SELF_SCHEDULE_INVITE_MODEL = "self-schedule-invite";

const selfScheduleInviteModel = {
  userId: ""
};

export default selfScheduleInviteModel;
